/**
 * Standalone: Error Page
 *
 * Adds/removes a class to error pages, called `site-header--scrolled`
 *
 * This code was orignally in this file:
 *   src/assets/js/app/errorPage.js
 * However, it was also implemented via `_hasScrolled()` in this file:
 *   src/assets/js/modules.js
 * Therefore, this script file may not need to be used, until/unless the error
 * page switches to V3. It's enqueued anyway, just to be safe, via:
 *   library/404-error.php
 *
 * @todo: This should be in either the module/v2/v3 folder. It's not
 * technically standalone because it still gets enqueued
 *
 * @module modules/SErrorPage
 */


// Dependances
// ============================================================================

import { $ } from '../common/utility/u-jquery-$';


// Main
// ============================================================================

// This custom body class (`bodyError`) is added via: library/404-error.php
// @NOTE: 404 pages automatically have the class `error404` added to their
// body tag, so checking `error404` may be preferred.
if ( $( 'body' ).hasClass( 'bodyError' ) )
{
	$( window ).on('scroll', function()
	{
		let top = $( window ).scrollTop();

		if ( top > 0 )
		{
			$( '#site-header' ).addClass( 'site-header--scrolled' );
		}
		else
		{
			$( '#site-header').removeClass('site-header--scrolled' );
		}
	});
}
